import { Button, Empty, ConfigProvider, Skeleton } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ExceptionOutlined, ReloadOutlined, PlusOutlined } from '@ant-design/icons'
import { PageHeaderWithHelpIcon } from '../../components/Generics/page-header-with-help-icon'
import { useHistory } from 'react-router-dom'
import { ComplaintList } from '../../components/complaint/list'
import { HelpDrawer } from '../../components/Generics/help-drawer'
import styles from './section.module.scss'
import ButtonComponent from '../Generics/Button'
import { FilterComplaints } from './filter-complaints'
import classNames from 'classnames'
import { SearchComplaintList } from './search-complaints-by-title'

const NewComplaintButton = ({ complaints }) => {
  const i18n = useTranslation()
  const history = useHistory()

  const classNameButton = classNames({
    [styles.first_complaint_button]: complaints?.length === 0,
    [styles.new_complaint_button]: complaints?.length > 0
  })

  const handleOnClick = () => history.push('/logbook/complaints/new')
  return (
    <div className={classNameButton}>
      <ButtonComponent
        buttonText={complaints && complaints.length > 0 ? i18n.t('pages.logbook.new.label') : i18n.t('pages.logbook.new.label_first')}
        colorType='primary' icon={<PlusOutlined />}
        shape='rectangle'
        onClick={handleOnClick}
      />
    </div>
  )
}

export const ComplaintsSection = ({ complaints, mutate, error, isLoading, isValidating }) => {
  const i18n = useTranslation()
  const [open, setOpen] = useState(false)
  const showDrawer = () => setOpen(true)
  const closeDrawer = () => setOpen(false)

  if (!complaints) return null

  const errorRenderEmpty = () => (
    <Empty description={i18n.t('common.resources.generic.actions.any.failure')} image={<ExceptionOutlined style={{ fontSize: 96 }} />}>
      <Button icon={<ReloadOutlined />} onClick={() => mutate()}>{i18n.t('common.resources.generic.actions.any.try-again')}</Button>
    </Empty>
  )

  const customizeRenderEmpty = () => (
    <Empty description={i18n.t('common.resources.complaint.label', { count: 0 })}>
      <NewComplaintButton complaints={complaints} />
    </Empty>
  )

  return (
    <ConfigProvider renderEmpty={error ? errorRenderEmpty : customizeRenderEmpty}>
      <Skeleton active loading={isLoading || isValidating}>
        <PageHeaderWithHelpIcon title={i18n.t('pages.logbook.index.title')} titleLevel={2} iconOnClick={showDrawer} />
        <ComplaintList
          complaints={complaints || []}
          header={complaints.length > 0 &&
            <div className={styles.header_wrapper}>
              <NewComplaintButton complaints={complaints} />
              <SearchComplaintList placeholder={i18n.t('common.resources.generic.actions.any.search_by_title')} />
              <FilterComplaints />
            </div>}
        />
        <HelpDrawer prefix='pages.logbook.index' title={i18n.t('pages.logbook.index.title')} open={open} onClose={closeDrawer} />
      </Skeleton>
    </ConfigProvider>
  )
}
